import React, { useState, useEffect, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserArea } from '../../../contexts/UserContext'; // ✅ Usar contexto
import { t } from 'i18next';
import { Area } from '../../../types/common.types';

interface ProtectedRouteProps {
	element: ReactElement;
	allowedAreas: Area[];
	authChecked: boolean;
	isLoggedIn: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ element, allowedAreas, authChecked, isLoggedIn }) => {
	const { area } = useUserArea();
	const [loading, setLoading] = useState<boolean>(true);

	useEffect(() => {
		if (area !== null && area !== undefined) {
			setLoading(false);
		}
	}, [area]);

	if (!authChecked) {
		return <p>{t('common.verifyAuth')}</p>;
	}

	if (!isLoggedIn) {
		return <Navigate to='/' />;
	}

	if (loading) {
		return <p>{t('common.loading')}</p>;
	}

	// Verificar que area es un array antes de llamar a some
	const hasAccess =
		allowedAreas &&
		Array.isArray(area) &&
		area.some((userArea) => allowedAreas.includes(userArea));
	if (!hasAccess) {
		return <Navigate to='/casos' />;
	}

	return element;
};

export default ProtectedRoute;
